export function toggle_loader(timeout = true) {
	setTimeout(function() {
		document.body.classList.add('loading');
	
		if(timeout) {
			setTimeout(function() {
				disable_loader();
			}, 15000);
		}
	}, 100);
}

export function disable_loader() {
	setTimeout(function() {
		document.body.classList.remove('loading');
	}, 500);
}

document.addEventListener('click', function (event) {

	if (!event.target.matches('.toggle-loader')) return;

	toggle_loader();

}, false);